import angular from 'angular';
import SearchAndSelectDirective from './search-and-select.directive';

let SearchAndSelectModule = angular.module('search-and-select-module', [])

    .directive('searchAndSelect', SearchAndSelectDirective)

    .name;

export default SearchAndSelectModule;


// WEBPACK FOOTER //
// ./client/app/common/search-and-select/index.js